/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Domain
 */
export interface Domain {
    /**
     * The unique identifier of the `Domain`
     * @type {string}
     * @memberof Domain
     */
    id: string;
    /**
     * The ID of the `User` that owns this `Domain`
     * @type {string}
     * @memberof Domain
     */
    user: string;
    /**
     * The domain name (e.g. hostname of the website)
     * @type {string}
     * @memberof Domain
     */
    name: string;
    /**
     * The subscription billing interval for this `Domain`
     * @type {string}
     * @memberof Domain
     */
    interval?: DomainIntervalEnum;
    /**
     * The current status of this `Domain`
     * @type {string}
     * @memberof Domain
     */
    status: DomainStatusEnum;
    /**
     * The plan type of this `Domain`
     * @type {string}
     * @memberof Domain
     */
    type: DomainTypeEnum;
    /**
     * The subscription expiry date for this `Domain`
     * @type {Date}
     * @memberof Domain
     */
    expires?: Date;
    /**
     * Whether the subscription auto-renews
     * @type {boolean}
     * @memberof Domain
     */
    renew?: boolean;
    /**
     * The timezone for this `Domain`
     * @type {string}
     * @memberof Domain
     */
    timezone?: string;
    /**
     * Whether Google Analytics tracking is enabled
     * @type {boolean}
     * @memberof Domain
     */
    trackGA?: boolean;
    /**
     * Whether conversion tracking is enabled
     * @type {boolean}
     * @memberof Domain
     */
    trackConversion?: boolean;
    /**
     * Alternative domain names that resolve to this `Domain`
     * @type {Array<string>}
     * @memberof Domain
     */
    aliases?: Array<string>;
    /**
     * Additional key-value properties for this `Domain`
     * @type {{ [key: string]: string; }}
     * @memberof Domain
     */
    properties?: { [key: string]: string; };
}


/**
 * @export
 */
export const DomainIntervalEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type DomainIntervalEnum = typeof DomainIntervalEnum[keyof typeof DomainIntervalEnum];

/**
 * @export
 */
export const DomainStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Suspended: 'SUSPENDED',
    Trialing: 'TRIALING'
} as const;
export type DomainStatusEnum = typeof DomainStatusEnum[keyof typeof DomainStatusEnum];

/**
 * @export
 */
export const DomainTypeEnum = {
    Free: 'FREE',
    Pro: 'PRO',
    Starter: 'STARTER'
} as const;
export type DomainTypeEnum = typeof DomainTypeEnum[keyof typeof DomainTypeEnum];


/**
 * Check if a given object implements the Domain interface.
 */
export function instanceOfDomain(value: object): value is Domain {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function DomainFromJSON(json: any): Domain {
    return DomainFromJSONTyped(json, false);
}

export function DomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): Domain {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user': json['user'],
        'name': json['name'],
        'interval': json['interval'] == null ? undefined : json['interval'],
        'status': json['status'],
        'type': json['type'],
        'expires': json['expires'] == null ? undefined : (new Date(json['expires'])),
        'renew': json['renew'] == null ? undefined : json['renew'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'trackGA': json['trackGA'] == null ? undefined : json['trackGA'],
        'trackConversion': json['trackConversion'] == null ? undefined : json['trackConversion'],
        'aliases': json['aliases'] == null ? undefined : json['aliases'],
        'properties': json['properties'] == null ? undefined : json['properties'],
    };
}

export function DomainToJSON(json: any): Domain {
    return DomainToJSONTyped(json, false);
}

export function DomainToJSONTyped(value?: Domain | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user': value['user'],
        'name': value['name'],
        'interval': value['interval'],
        'status': value['status'],
        'type': value['type'],
        'expires': value['expires'] == null ? value['expires'] : value['expires'].toISOString(),
        'renew': value['renew'],
        'timezone': value['timezone'],
        'trackGA': value['trackGA'],
        'trackConversion': value['trackConversion'],
        'aliases': value['aliases'],
        'properties': value['properties'],
    };
}

